<script>
    import axios from 'axios'
    import {Listeners} from "../../../constants/listeners";
    import AdaptersDialog from "../../../component/adapters/Dialog.vue";

    export default {
        data () {
            return {
                name: 'groupDeleteGroupReport',
                loading: false,
                error: null,
                currentReportData: {},
            }
        },
        mounted() {
            this.$emitter.on(Listeners.KS_DELETE_REPORT, eventData => this.onDeleteReport(eventData));
        },
        methods: {
            onDeleteReport(data) {
                this.currentReportData = data;
                this.$emitter.emit(this.getListenerId);
            },
            deleteReport(){
                let self = this;
                self.loading = true;

                axios({
                    method: 'delete',
                    url: this.getApiUrl,
                    withCredentials: true,
                })
                    .then(function (response) {

                        self.loading = false;
                        self.$emitter.emit(self.getListenerCancelId);
                        self.$emitter.emit(Listeners.KS_FILTER_REFRESH);
                        self.$emitter.emit(Listeners.RELOAD_GROUP_REPORTS_LIST);

                    })
                    .catch(function (error) {
                        self.loading = false;
                        self.error = error.response.data.message;
                    });
            },
            onClose() {
                this.$emitter.emit(this.getListenerCancelId);
            }
        },
        computed: {
            getApiUrl(){
                return this.$config.API_URL + '/report/group/' + this.currentReportData.rid;
            },
            getListenerId() {
                return Listeners.KS_POPUP_DELETE_GROUP_REPORT_OPEN;
            },
            getListenerCancelId() {
                return Listeners.KS_POPUP_DELETE_GROUP_REPORT_CLOSE;
            }
        },
        components: {
            AdaptersDialog
        }
    }
</script>
<template>
    <AdaptersDialog
        :listener-id="getListenerId"
        :listener-close-id="getListenerCancelId"
        :header="$t('lang.group_report.delete_report')"
        :loading="loading"
        :error-message="error"
        :button-agree-label="$t('lang.main.btn.delete')"
        :callback-agree="deleteReport"
    >
        <template #content>
            <div class="grid">
                <div class="col">
                    <p class="text-overflow-ellipsis overflow-hidden" v-html="$t('lang.group_report.ays_del_report', [currentReportData.name])" />
                </div>
            </div>
        </template>
    </AdaptersDialog>
</template>
